<template>
  <div id="software">
     <div class="text">
        <p>一、项目概况</p>
        <p>
        全链条物流、仓储管理解决方案是为企业打造的一体化运营体系，贯穿从采购端到消费端的全流程，通过整合资源、优化流程和数字化赋能，实现物流与仓储环节的高效协同。本方案以数字化、智能化为核心，通过整合资源、优化流程和协同运作，助力企业提升物流效率、降低运营成本、增强市场竞争力，适用于制造业、电商、零售、生鲜等多个行业。
        </p>
        <p>二、建设目标</p>
        <p>
          建设订单管理系统、揽收管理系统、物流管理系统、仓储管理系统，形成免税店包裹拦收、物流、仓储、提货全闭环流程服务；
         </p>
        <p>
          基于业务数据开发数据分析应用，实时展现货物流转总体情况；
        </p>
        <p>
          对业务数据自主管理，保障用户和企业的数据隐私安全，为将来与外部平台共享数据拓展新业务打下基础。
        </p>
        <p>三、用户分析</p>
        <p>
          <p>1、物流调度人员：查看免税店发送的提货订单，安排调配物流车辆和司机，发送订单至免税店揽货点。</p>
          <p>2、揽收人员：查看订单，开始揽货并打包货品，完成打包后打印交接单一并移交物流司机。</p>
          <p>3、物流司机：从揽收点取货，将货品运送至指定提货点并交接仓库人员。</p>
          <p>4、仓储人员/提货点员工：接受货品后将货物上架，打印取货码并贴码，待离岛客户提货交付。</p>
        </p>
        <p>四、订单管理</p>
          <p>1、订单管理：实时跟踪更新订单状态，对异常单流转进行干预处理。</p>
          <p>2、揽收管理：对免税店免税货品进行揽收交接物流处理。</p>
          <p>3、物流司机：负责免税货品物流派车、跟踪、货品交接等物流相关业务。</p>
          <p>4、仓储人员/提货点员工：包含提货点品入库、盘点、出库、退货等业务。</p>
        <p>五、业务模型</p>
        <div class="flex">
          <img
            src="@/assets/images/20250724/ruanjian/tihuo1.jpg"
            style="width: 100%;"
            alt=""
          />
        </div>
        <p>
        订单从商店开始，下发至公服平台，再由公服平台推送至提货平台，订单在提货平台首先进入揽收管理系统；
        揽收员接收订单后首先向物流公司申请派车，同时对从分拣系统发送的包裹进行揽收打包；
        然后调度员在物流管理系统分配货车和司机；司机在手机上接收任务后，前往达揽收点，到达后，出示二维码；之后揽收员扫码开始装车；装车过程需司机拍照打卡，装车完成后向提货点仓库出发，货车行驶期间系统会自动记录轨迹；
        到达提货点后，司机与仓储员工交接大包裹，然后由仓库管理员对小包裹进行贴码上架，上架完成的商品会向客户发送提货码；最后，客户再取件。
        至此，提货业务大体正向业务流程完成。
        </p>
        <p>六、总体架构设计</p>
          <div class="flex">
          <img
            src="@/assets/images/20250724/ruanjian/tihuo2.jpg"
            style="width: 100%;"
            alt=""
          />
        </div>
         <p>最底下是基础层，包括应用服务器、数据库服务器、代理服务器等，提供平台运行的计算、存储和网络资源
          往上是数据中心和支撑应用，数据中心包含用户、业务以及共享数据库，支撑应用提供身份认证、消息推送、预警监控等服务
          中间是订单管理、揽收管理、物流管理和仓储管理系统，未来新增的应用都在这部分体现
          再往上是对外部分，包括对外提供统一的标准数据和便捷服务
          最后就是平台服务的用户角色，包括商店店、运营人员、消费者等。
          </p>
        <p>七、建设内容</p>
        <p>揽收管理系统：揽收管理系统维护商店货品揽收业务，并管理货品派发与交接。通过建设揽收管理系统，提供订单管理、批次管理、分拣装箱、运输单管理等功能实现商店货品揽收业务管理。</p>
        <p>物流管理系统：物流管理系统维护免税货品物流派车、跟踪、货品交接等物流相关业务。通过建设物流管理系统,提供运单处理、车辆调度、车辆跟踪、货品交接等功能,实现物流全程闭环跟踪。</p>
        <p>仓储管理系统：仓储管理系统维护提货点的货品入库、盘点、出库、退货。通过建设仓储管理系统，提供扫码拣货、上架、盘库、取件等功能，实现货品仓储和提货服务。</p>
        <p>其他内容：包含提货小程序、硬件适配、权限管理、第三方系统对接等等。</p>
      </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution10.vue